export default {
  hashCode (str) {
    return !str ? null : str.split('').reduce((prevHash, currVal) =>
      (((prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0, 0)
  },
  getValue (obj, path) {
    const get = (p, o) => p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, o)
    return get(path, obj)
  },
  uniqBy (a, key) {
    let seen = new Set()
    return a.filter(item => {
      let k = item[key]
      return seen.has(k) ? false : seen.add(k)
    })
  },
  blank (v, formatter, msg) {
    msg = msg || '-'
    return (!v && msg) || (v && v === 'null' && msg) || formatter && formatter(v) || v
  },
  isDate (date) {
    return (new Date(date) !== 'Invalid Date') && !isNaN(new Date(date))
  },
  formatDate (dateTime) {
    return new Date(dateTime).toLocaleDateString(navigator.languages)
  },
  formatDateToISO (dateTime) {
    var d = new Date(dateTime)
    // console.log('formatDateToISO', d.toISOString().slice(0, 10))
    return d.toISOString().slice(0, 10)
  },
  formatDateTime (dateTime) {
    return new Date(dateTime).toLocaleString(navigator.languages)
  },
  formatTime (dateTime) {
    return new Date(dateTime).toLocaleTimeString(navigator.languages)
  },
  formatCurrency (number) {
    return number.toLocaleString(navigator.languages)
  },
  formatNumber (number) {
    return number.toLocaleString(navigator.languages, {minimumFractionDigits: 1, maximumFractionDigits: 2})
  },
  isString (v) {
    return (Object.prototype.toString.call(v) === '[object String]')
  },
  compareString (a, b) {
    return a ? a.localeCompare(b, 'ru', { sensitivity: 'base' }) : (b ? -1 : 0)
  },
  isRefCode (v) {
    return /^(nza:\d{11}|ogrn:\d{13}|ogrnip:\d{15})$/.test(v)
  },
  splitRefCode (v) {
    if (!this.isRefCode(v)) {
      return {}
    }
    return {type: v.split(':')[0], code: v.split(':')[1]}
  },
  isOgrn (v) {
    return /^[1-9][0-9]{12}$/.test(v)
  },
  isInn (v) {
    return /^(?:(?!00)\d{10}|(?!0)\d{9})$/.test(v)
  },
  formatInn (v) {
    return Number(v).toLocaleString(navigator.languages, {useGrouping: false, minimumIntegerDigits: 10})
  },
  isRefCodes (v) {
    return /^(?:(?:(ogrn:)\d{13}|(nza:)\d{11}|(ogrnip:)\d{15})[\s,]*)+$/g.test(v)
  },
  splitRefCodes (v) {
    let re = /(?:(ogrn:)\d{13}|(nza:)\d{11}|(ogrnip:)\d{15})/g
    return v ? v.match(re) || [] : []
  },
  isInns (v) {
    return /^(?:(?:(?!00)\d{10}|(?!0)\d{9})[\s,]*)+$/g.test(v)
  },
  splitInns (v) {
    let re = /(?:(?!00)\d{10}|(?!0)\d{9})/g
    return v ? v.match(re) || [] : []
  },
  isInnfl (v) {
    return /^(?:(?!00)\d{12}|(?!0)\d{11})$/.test(v)
  },
  formatInnfl (v) {
    return Number(v).toLocaleString(navigator.languages, {useGrouping: false, minimumIntegerDigits: 12})
  },
  isDepoUid (v) {
    return /^[2]\d{19}$/.test(v)
  },
  splitDepoUids (v) {
    let re = /(?:[2]\d{19})/g
    return v ? v.match(re) || [] : []
  },
  isEmail (v) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Zа-яёА-ЯЁ\-0-9]+\.)+[a-zA-Zа-яёА-ЯЁ]{2,}))$/
    return re.test(String(v).toLowerCase())
  },
  isEmails (v) {
    let vs = v.split(/[, ]+/)
    let result = vs.length > 0
    for (var i = 0; i < vs.length; i++) {
      result = result && this.isEmail(vs[i])
    }
    return result
  },
  isPhone (v) {
    let re = /^(\+)?([0-69]){1,3}\(\d{1,5}\)(\d){4,8}(x\d*)?$/
    const re1 = /^(\+7|8)(\(\d{3}\)\d{7}|\(\d{4}\)\d{6}|\(\d{5}\)\d{4,5})(x\d*)?$/
    return re1.test(v) || re.test(v)
  },
  formatPhone (v) {
    const _a = (a, n) => a.length > n && a[n] ? a[n] : ''
    if (!v) {
      return ''
    }
    let ms = v.match(/^(\+?\d+)\D+(\d*)\D+([\d\s-]*)[^\d\s-]*([\d\s-]*)?\D*$/)
    if (!ms) {
      ms = v.match(/^(\+?\d{1})(\d{3})([\d\s-]*)[^\d\s-]*([\d\s-]*)?\D*$/)
    }
    if (ms) {
      let c = ms.length > 1 ? (ms[1] === '8' ? '+7' : ms[1]) : ''
      c = (c[0] !== '+') && ('+' + c) || c
      let o = _a(ms, 2)
      let n = _a(ms, 3).replace(/\D/g, '')
      let x = _a(ms, 4).length > 0 ? 'x' + _a(ms, 4).replace(/\D/g, '') : ''
      let result = `${c}(${o})${n}${x}`
      return result
    }
    return v
  },
  isPassword (v) {
    var re = /^(?=.*\d)(?=.*[a-zA-Z]).{4,}$/
    return re.test(String(v))
  },
  isBankAccount (v) {
    const re = /^\d{20}$/
    return re.test(String(v))
  },
  isBankRcbic (v) {
    const re = /^\d{9}$/
    return re.test(String(v))
  },
  isSnils (v) {
    const re = /^\d{11}$/
    return re.test(String(v))
  },
  isNameRu (v, size) {
    const re = new RegExp(`^[А-ЯЁ][а-яёА-ЯЁ -']{1,${size - 1}}$`)
    return re.test(String(v))
  },
  isNameLat (v, size) {
    const re = new RegExp(`^[A-Z][a-zA-Z-]{1,${size - 1}}$`)
    return re.test(String(v))
  },
  parseSearchTerms (v) {
    // Парсинг с учетом пробелов внутри кавычек
    let re = /(?:"((?:[^"]|"")*)"|([^a-zA-Zа-яёА-ЯЁ"\s]+)|([^"\s]{3,}))/g
    const arr = [...(v && v.toLowerCase().matchAll(re) || [])].map(i => `${i[1] || i[0]}`.replaceAll(/""/g, '"'))
    return arr
  },
  stringifySearchTerms (terms) {
    return terms && terms.map(t => /\s/.test(t) && `"${t.replaceAll(/"/g, '""')}"` || t).join(' ')
  },
  createComp (template) {
    return {template: template}
  },
  formatSuccessHtml (warning) {
    return warning && warning.length > 0 ? '<span class="success--text">' + warning + '</span>' : ''
  },
  formatWarningHtml (warning) {
    return warning && warning.length > 0 ? '<span class="warning--text">' + warning + '</span>' : ''
  },
  formatErrorHtml (error) {
    return error && error.length > 0 ? '<b><span class="error--text">' + error + '</span></b>' : ''
  }
}



// WEBPACK FOOTER //
// ./src/api/formats.js